
  if (window.location.pathname === '/lite' || window.location.pathname.indexOf('/lite/') === 0) {
    import('/src/lite-main.tsx');
  } else {
    import('/src/main.tsx');
  }
